import React from "react";
import { Link } from "react-router-dom";
import Register from "./pages/Register";
import logo from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/img/square-logo-with-text-v2.png";

function RegisterView() {
  return (
    <div className="auth-login-page">
      <div className="auth-login-brand">
        <Link to="/" className="auth-login-brand-link">
          <img
            src={logo}
            alt="Lesson Launchpad"
            className="auth-login-brand-logo"
          />
        </Link>
      </div>
      <div className="auth-login-panel">
        <div className="auth-login-panel-inner auth-login-panel-inner--register">
          <Register />
        </div>
      </div>
    </div>
  );
}

export default RegisterView;
